import st from './Textarea.module.scss';
import clockIco from "../Icons/ico-clock.svg";


type TextareaType = {

    placeholder?: string;
    value?: any;
    onChange?: (value: any) => void;
    name?: string;
    ico?: 'clock' | 'blank';
    style?: any;

}

function Textarea({ placeholder = '', name, value, onChange, ico, style }: TextareaType) {
    return (<div className={st.textarea_container}>
        <textarea style={style} className={st.textarea + ' ' + st.row}
            placeholder={placeholder}
            onChange={onChange} name={name} value={value} />
        {ico === 'clock' ? <img src={clockIco} data-tooltip-id="form-tooltip"
            data-tooltip-content="Changes to this field require moderation"
            alt={'Changes to this field require moderation'} /> : ''}
    </div>
    );
}

export default Textarea